import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * Shared outer wrapper for registry timeline cards (application, application-report,
 * planting, note, visit). The recommendation card intentionally uses its own highlighted
 * variant and does not use this component.
 */
export const RegistryCard = ({ children }: { children: ReactNode }) => (
    <Stack
        spacing={2}
        sx={{
            bgcolor: 'background.paper',
            border: 1,
            borderColor: 'primary.mui.stroke',
            borderRadius: 2,
            boxShadow: '0px 1px 0.5px rgba(0, 0, 0, 0.14)',
            p: 2,
        }}
    >
        {children}
    </Stack>
);
